export const DEFAULT_TIP_PERCENTAGES = [18, 20, 22];
export const MAX_TIP_PERCENTAGE = 100;

const isValidPercentage = (value) =>
  Number.isFinite(value) && value > 0 && value <= MAX_TIP_PERCENTAGE;

export const resolveTipPercentages = (displaySettings) => {
  const saved = displaySettings?.tip_percentages;
  if (!Array.isArray(saved) || saved.length !== DEFAULT_TIP_PERCENTAGES.length) {
    return DEFAULT_TIP_PERCENTAGES;
  }

  const percentages = saved.map(Number);
  return percentages.every(isValidPercentage) ? percentages : DEFAULT_TIP_PERCENTAGES;
};

export const getTipPercentageError = (input) => {
  const text = `${input ?? ''}`.trim();

  if (!text) return 'Enter a tip percentage';
  if (text.startsWith('-')) return "Tip can't be negative";
  if (!/^\d*\.?\d{0,2}$/.test(text)) return 'Enter a number with up to 2 decimals';

  const percentage = parseFloat(text);
  if (!Number.isFinite(percentage) || percentage <= 0) return 'Tip must be more than 0%';
  if (percentage > MAX_TIP_PERCENTAGE) return `Tip can't be more than ${MAX_TIP_PERCENTAGE}%`;

  return null;
};
